module.exports = __webpack_public_path__ + "media/store/images/icon-buttons/spacing-vertical-65acd9ed2b33361b5e0110618f22a940.svg";